<template>
  <v-item-group
    class="cfs-switch d-flex"
    :class="{ 'tabs-style': isTabsStyle }"
    mandatory
    :value="value"
    @change="onItemGroupChange"
  >
    <v-item v-for="item in items" :key="item" v-slot="{ toggle, active }" :value="item">
      <div
        class="cfs-switch__item d-flex align-center text--white cursor-pointer"
        :class="{ active }"
        @click="toggle"
      >
        {{ item }}
      </div>
    </v-item>
  </v-item-group>
</template>

<script>
export default {
  name: 'CfsSwitchComponent',
  props: {
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
    value: {
      type: [String, Object, Number],
      default: '',
    },
    isTabsStyle: {
      type: Boolean,
      default: true,
    },
  },

  methods: {
    onItemGroupChange(value) {
      this.$emit('input', value);
    },
  },
};
</script>
